module.exports = __webpack_public_path__ + "img/avatar-s-18.3622d7f0.jpg";